export default {
    mapper: {
        relations: {
            belongsTo: {
                facility: {
                    foreignKey: 'facility_id',
                    localField: 'facility',
                },
                user: {
                    foreignKey: 'user_id',
                    localField: 'user',
                },
            },
        },
    },
};
